import React, {useState, useEffect} from 'react'
import Modal from 'components/utils/Modal'
import SearchBar from 'components/utils/SearchBar'

import { formatDateYMD, filterData } from 'scripts/common'

import { selectData } from 'scripts/offline'

const Curve = (props) => {

  const [fetchedData, setFetchedData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const fetchData = () => {

    if (props.user.offline && props.user.offlineJob === props.filter.jobNumber) {

      selectData('TestCurves').then(res => setFetchedData(res))

    } else {

      fetch('/api/selectMenuCurves', {
        method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          jobNumber: props.filter.jobNumber
        })
      })
      .then(res=>res.json())
      .then(
        (result) => {
          //console.log('result: ' + result)
          setFetchedData(result)
        },
        (error) => {
          console.log('Error: selectMenuCurves --> ' + error)
        }
      )

    }

  }

  useEffect(() => {
    fetchData()
  }, [])

  const search = (e) => {
    let value = e.target.value
    setSearchValue(value)
  }

  const clearSearch = () => {
    document.getElementById('searchInput').value = ''
    setSearchValue('')
  }

  let listOfData = fetchedData.map(data => {

    //id, curve, optd, optm, color, additionalcolor, description, location, represents

    let sampleDate = data.sampledate === null || data.sampledate === '' ? '' : formatDateYMD(data.sampledate)
    let curve = data.curve === null ? '' : data.curve
    let optd = data.optd === null ? '' : data.optd
    let optm = data.optm === null ? '' : data.optm
    let location = data.location === null ? '' : data.location
    let represents = data.represents === null ? '' : data.represents
    let description = data.description === null ? '' : data.description
    let color = data.color === null ? '' : data.color
    let additionalColor = data.additionalcolor === null ? '' : data.additionalcolor

    let filter = filterData(data, searchValue)

    if (filter) {
      return (
        <tr key={data.id.toString()} onClick={props.selectCurve}>
          <td style={{display: 'none'}}>{data.id}</td>
          <td>{sampleDate}</td>
          <td>{curve}</td>
          <td>{optd}</td>
          <td>{optm}</td>
          <td>{location}</td>
          <td>{represents}</td>
          <td>{description}</td>
          <td>{color}</td>
          <td>{additionalColor}</td>
        </tr>
      )
    }

  })

  let content = (
    <div>

      <SearchBar search={search} clearSearch={clearSearch} />

      <div style={{width: '100%', height: '100%', textAlign: 'center'}}>

        <div style={{display: 'inline-block', textAlign: 'center', marginTop: 10}}>

          <table>

            <thead>
              <tr>
                <th>Sample Date</th>
                <th>Curve</th>
                <th>Opt Dens (pcf)</th>
                <th>Opt M (%)</th>
                <th>Location</th>
                <th>Represents</th>
                <th>Desc.</th>
                <th>Color</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {listOfData}
            </tbody>

          </table>

        </div>

      </div>

    </div>
  )

  return <Modal content={content} closeModal={props.closeModal} zIndex={props.zIndex} />
}

export default Curve
